import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../problems/problem.service';
import { ConfigService } from '../../config/config.service';
import { TaskGridSavedFilter } from './definitions/task-grid-saved-filter.interface';

@Injectable()
export class PostUserDefaultFilters {
  private apiUrl: string = this.configService.config.rest.apiV2Url;

  constructor(
    private client: HttpClient,
    private configService: ConfigService
  ) {}

  public postDefaultFilters(filters: TaskGridSavedFilter): Observable<void> {
    const url = `${this.apiUrl}/me/settings/task-grid/default-filter`;
    return this.client
      .post<void>(url, filters)
      .pipe(
        catchError((error) => throwError(() => handleProblem(error)))
      );
  }
}
